export default __webpack_public_path__ + "static/media/noFound.cbae8280.svg";